'use client';

import 'BomdisoftComponents/language-offer/styles.css';
import { CloseRoundedIcon } from 'BomdisoftComponents/icons/close-rounded';
import { decideLanguageOffer, recordLanguageChoice, recordLanguageOfferDismissed } from 'BomdisoftComponents/language-offer/offer';
import { DEFAULT_LANGUAGE_OFFER_TEST_ID, toLanguageOfferCopy } from 'BomdisoftComponents/language-offer/render';
import { Tooltip } from 'BomdisoftComponents/tooltip/index';
import type { SupportedLanguageCode } from '@bomdisoft/translations';
import { useEffect, useState } from 'react';

export { offeredLocale } from 'BomdisoftComponents/language-offer/offer';

export type LanguageOfferProps = {
  testId?: string;
};

export const LanguageOffer = ({ testId = DEFAULT_LANGUAGE_OFFER_TEST_ID }: LanguageOfferProps) => {
  const [offered, setOffered] = useState<SupportedLanguageCode | undefined>(undefined);

  useEffect(() => {
    setOffered(decideLanguageOffer(window));
  }, []);

  if (!offered) return null;

  const copy = toLanguageOfferCopy(offered);

  return (
    <div className='bomdisoft-language-offer' data-testid={testId} dir={offered === 'ar' ? 'rtl' : 'ltr'} lang={offered}>
      <p className='bomdisoft-language-offer-text'>
        {copy.lead}
        <b className='bomdisoft-language-offer-name'>{copy.name}</b>
        {copy.trail}
      </p>
      <a className='bomdisoft-language-offer-action' data-testid={`${testId}-action`} href={`/${offered}`} onClick={() => recordLanguageChoice(window, offered)}>
        <span className='bomdisoft-language-offer-action-full'>{copy.action}</span>
        <span className='bomdisoft-language-offer-action-short'>{copy.actionShort}</span>
      </a>
      <Tooltip title={copy.dismiss}>
        <button
          aria-label={copy.dismiss}
          className='bomdisoft-language-offer-dismiss'
          data-testid={`${testId}-dismiss`}
          onClick={() => {
            recordLanguageOfferDismissed(window);
            setOffered(undefined);
          }}
          type='button'
        >
          <CloseRoundedIcon size={18} />
        </button>
      </Tooltip>
    </div>
  );
};
